import "./insHorizontalBarDatapointChart.scss";
import { Chart, wrap } from "highcharts/highstock";
import React, { useRef } from "react";
import { renderToStaticMarkup } from "react-dom/server";
import { ManageScroll } from "./ins-horizontal-bar-chart-scrolling";
import { useCalculateDesign } from "./ins-horizontal-bar-datapoint-chart-helper";
import { InsLabelValueTooltip } from "components/widgets/base/common/insLabelValueTooltip";
import { InsHighcharts } from "components/widgets/base/insHighcharts";
import { InsQueryStatedElement } from "components/widgets/base/insQueryStatedElement";
wrap(Chart.prototype, "render", ManageScroll);
export const InsBaseHorizontalBarChart = (props) => {
    const chartContainerRef = useRef(null), chartRef = useRef(null);
    if (props.options) {
        props.options.tooltip = {
            formatter() {
                return renderToStaticMarkup(React.createElement(InsLabelValueTooltip, { labelValuePairs: this.point.options.custom?.tooltip || [] }));
            }
        };
        props.options.plotOptions = {
            ...props.options.plotOptions,
            bar: {
                ...props.options.plotOptions?.bar,
                turboThreshold: 0
            }
        };
    }
    useCalculateDesign({ chartContainerRef,
        chartRef,
        childrenId: props.childrenId,
        data: props.series?.[0]?.map((p) => ({ name: p.name, value: p.custom?.formatted ?? "" })) || [],
        dataLabelsEnabled: props.enableLabels,
        masterDetailChoiceIndex: props.masterDetailChoiceIndex,
        noDefineLabel: false,
        options: props.options || {},
        preformatted: true });
    return React.createElement(InsQueryStatedElement, { widgetFactoryProps: props, queryState: props.queryState, hasData: props.hasData },
        React.createElement(InsHighcharts, { key: props.chartKey, options: props.options, ref: chartRef, wrapperRef: chartContainerRef, containerClassName: props.showScale ? "default-horizontal-bar-chart" : "scaleless-horizontal-bar-chart", colorSet: props.colorSet, sectionId: props.sectionId, widgetId: props.widgetId, isMaximizedOne: props.isMaximizedOne }));
};
